export default __webpack_public_path__ + "static/media/programs-table-empty.da3023b9.svg";